import React from "react";
import { BoxIcon } from "lucide-react";
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description?: string;
}
export function EmptyState({
  icon: Icon,
  title,
  description
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-slate-200 px-6 py-10 text-center" data-id="element-141" data-mp="1oebcw3kbj8ul">
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-slate-100" data-id="element-142" data-mp="1sc91b469lqwx">
        <Icon className="h-5 w-5 text-slate-400" data-id="element-143" data-mp="vmhuq6kp8dar" />
      </div>
      <p className="text-sm font-medium text-slate-600" data-id="element-144" data-mp="10o7au0ms3h5p">{title}</p>
      {description && <p className="text-xs text-slate-400" data-id="element-145" data-mp="14or7z47cqkru">{description}</p>}
    </div>;
}